import { Navigate, Outlet } from 'react-router-dom';
import { FC } from 'react';
import { homePathFor, PUBLIC_PATH } from '@/constants/paths';
import Loader from '@/components/Loader';
import { useAppSelector } from '@/hooks/useAppSelector';
import { selectAuthState } from '@/selectors/auth';

const PublicRoute: FC = (): JSX.Element => {
  const { user, isLoading } = useAppSelector(selectAuthState);

  if (isLoading) {
    return <Loader />;
  }

  // A role with no page of its own stays here rather than looping back to login.
  if (user && homePathFor(user.role) !== PUBLIC_PATH.LOGIN) {
    return <Navigate to={{ pathname: homePathFor(user.role) }} />;
  }

  return <Outlet />;
};

export default PublicRoute;
